import {
ACTION_STAFFAUTHORIZATIONGROUPLIST_SUCCESS
} from './action';
import createReducer from '../../../../reducers/createReducer';

const INITIAL_STATE = {
        data: [],
        loading: false
    };

const StaffAuthorizationGroupListReducer = createReducer(
	INITIAL_STATE,
	{
		[ACTION_STAFFAUTHORIZATIONGROUPLIST_SUCCESS](state, action) {
            return Object.assign({}, {
                ...state,
                data: action.payload.data,
                tag: ACTION_STAFFAUTHORIZATIONGROUPLIST_SUCCESS,
                loading: false
            });
        }
	}
);
export default StaffAuthorizationGroupListReducer;